import { render, staticRenderFns } from "./OrmMessageNewSideMenu.vue?vue&type=template&id=392454e1"
import script from "./OrmMessageNewSideMenu.vue?vue&type=script&lang=js"
export * from "./OrmMessageNewSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('392454e1')) {
      api.createRecord('392454e1', component.options)
    } else {
      api.reload('392454e1', component.options)
    }
    module.hot.accept("./OrmMessageNewSideMenu.vue?vue&type=template&id=392454e1", function () {
      api.rerender('392454e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ormmessage/OrmMessageNewSideMenu.vue"
export default component.exports